export const InterviewGridDateAndRoundUtil = {
  countBadgeLabel: (num: number): string => {
    const lastTwoDigits = num % 100;
    const lastDigit = num % 10;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${num}th`;
    }

    if (lastDigit === 1) {
      return `${num}st`;
    }

    if (lastDigit === 2) {
      return `${num}nd`;
    }

    return lastDigit === 3 ? `${num}rd` : `${num}th`;
  },
};
